var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCasinoLimitFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.124 3H4a1 1 0 00-1 1v16a1 1 0 001 1h16a1 1 0 001-1v-7.124a7.474 7.474 0 01-3 .624 7.466 7.466 0 01-4.318-1.367 1.687 1.687 0 11-1.816-1.816A7.466 7.466 0 0110.5 6c0-1.067.223-2.081.624-3zm6.046 14.17a1.687 1.687 0 10-2.386-2.386 1.687 1.687 0 002.386 2.387zM9.216 6.83a1.687 1.687 0 11-2.387 2.386 1.687 1.687 0 012.387-2.387z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 12a6 6 0 100-12 6 6 0 000 12zm-.457-4.915h.954l.135-4.01h-1.225l.136 4.01zm.942.8a.637.637 0 00-.465-.171.637.637 0 00-.466.174.58.58 0 00-.174.434c0 .175.058.32.174.433.12.114.275.17.466.17a.637.637 0 00.465-.17.573.573 0 00.178-.433.578.578 0 00-.178-.438z",
    fill: "currentColor"
  })));
}
SvgCasinoLimitFilled.displayName = 'CasinoLimitFilled';
export default SvgCasinoLimitFilled;